import { VerticalContainer } from '@american-autonomy/ag-ui';

import PrimaryButton from 'components/buttons/PrimaryButton';
import ParagraphText from 'components/text/ParagraphText';

import useJohnDeere from 'hooks/useJohnDeere';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const JohnDeereCallbackPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { error } = useData();
    const { connect } = useJohnDeere();
    const { CONNECTING, ERROR, TRY_AGAIN } = useTranslation();

    if (error) {
        return (
            <VerticalContainer className={styles.johnDeereCallbackPage} testId={testId}>
                <ParagraphText className={styles.errorMessage} text={ERROR} />

                <ParagraphText className={styles.errorMessage} text={error} />

                <PrimaryButton onClick={connect} text={TRY_AGAIN} />
            </VerticalContainer>
        );
    }

    return (
        <VerticalContainer className={styles.johnDeereCallbackPage} testId={testId}>
            <span className={styles.spinner} />

            <ParagraphText className={styles.statusMessage} text={CONNECTING} />
        </VerticalContainer>
    );
};

export default JohnDeereCallbackPage;
